import { useQuery } from "@tanstack/react-query";
import { fetchTestTasks } from "../services/api";
import { TestTask } from "../constants/AllTypes";
  
  export const useTestTasks = (lessonId: number, studentId: number, attempt: number, checkingResult: boolean) => {
    return useQuery({
      queryKey: ['testTasks', lessonId, studentId, attempt],
      enabled: !!lessonId && !!studentId && !!checkingResult,
      queryFn: async () => {
        if (!lessonId || !studentId) return null;
  
        // --- Try from localStorage first ---
        const localKey = `testTasks_${lessonId}_${studentId}_${attempt}`;
        let testTasks: TestTask[] | null = null;
  
        try {
          const stored = localStorage.getItem(localKey);
          if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
              testTasks = parsed;
            }
          }
        } catch (error) {
          console.error('Error parsing test tasks from localStorage:', error);
        }
  
        // --- Fallback to backend ---
        if (!testTasks || testTasks.length === 0) {
          try {
            const testResponse = await fetchTestTasks(lessonId, studentId, Number(attempt));
            testTasks = testResponse?.testTasks || [];
  
            // Cache locally for resilience
            if (testTasks && testTasks.length > 0) {
              localStorage.setItem(localKey, JSON.stringify(testTasks));
            }
          } catch (error) {
            console.error('Error fetching test tasks:', error);
          }
        }
  
        return testTasks || [];
      },
    });
  };